import axios from "./axios"

const postApi = async (apiCallRequest) => {
    let { url, data, config } = apiCallRequest
    return await axios.post(url, data, config)

}

export default postApi